import {translation} from "@2d-front-monorepo/core";
import {IMvvmContextState} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import AttachmentType from "../enums/AttachmentType";
import {CreateAttachmentsComponent} from "../index";
import ICreateComponentAttachments from "../interfaces/ICreateComponentAttachments";
import {AttachmentRequirements} from "../types/InstallationByHostData";

export interface FullCreateAttachmentsComponentProps {
	context: IMvvmContextState<ICreateComponentAttachments>;
	attachments: FullAttachmentConfiguration;
}

export interface FullAttachmentConfiguration extends AttachmentRequirements {
	updatable?: AttachmentType[];
}

export default function FullCreateAttachmentsComponent(props: FullCreateAttachmentsComponentProps): JSX.Element | undefined {
	const {context, attachments} = props;
	if (attachments.required.length === 0 && (attachments.updatable?.length ?? 0) === 0 && attachments.optional.length === 0) {
		return undefined;
	}

	return (
		<div className={"grid"}>
			<CreateAttachmentsComponent context={context}
			                            label={translation(PermitTranslations.documentation__required)}
			                            types={attachments.required}
			                            required={true}
			                            className={"col-1of2"}/>

			<CreateAttachmentsComponent context={context}
			                            label={translation(PermitTranslations.documentation__update)}
			                            types={attachments.updatable}
			                            required={false}
			                            className={"col-1of2"}/>

			<CreateAttachmentsComponent context={context}
			                            label={translation(PermitTranslations.documentation__additional)}
			                            types={attachments.optional}
			                            required={false}
			                            className={"col-1of2"}/>
		</div>
	);
};
